angular.module('picmonicng').controller('BrowseController', [
  '$scope',
  '$browseStateParams',
  '$timeout',
  '$rootScope',
  'BrowseService',
  function ($scope, $browseStateParams, $timeout, $rootScope, BrowseService) {
    try {
      $scope.visibleContent = localStorage.getItem('browse_section') || 'recent';
    } catch (e) {
      $scope.visibleContent = 'recent';
    }

    $scope.recentVisible = true;
    $scope.$browseStateParams = $browseStateParams;

    if (window.innerWidth < 480) {
      var lastScrollTop = 0;
      $('.browse__content').bind('touchmove', function (event) {
        if ($(this).scrollTop() > lastScrollTop) {
          if ($rootScope.bodyClass.indexOf('nav-browse-hidden-mobile') === -1 && !BrowseService.moreMenuOpen) {
            $scope.$apply(function () {
              $rootScope.bodyClass.push('nav-browse-hidden-mobile');
            });
          }
        } else if ($(this).scrollTop() < lastScrollTop) {
          if ($rootScope.bodyClass.indexOf('nav-browse-hidden-mobile') !== -1) {
            $scope.$apply(function () {
              $rootScope.bodyClass.splice($rootScope.bodyClass.indexOf('nav-browse-hidden-mobile'), 1);
            });
          }
        }

        lastScrollTop = $(this).scrollTop();
      });
    }

    if ($browseStateParams.playlist_id) {
      $scope.playlist_id = $browseStateParams.playlist_id;
    }

    $scope.toggleContent = function (section, category_title) {
      if ($scope.visibleContent == section) {
        $scope.visibleContent = null;
      } else {
        $scope.visibleContent = section;
        $scope.scrollToBlock();

        try {
          localStorage.setItem('browse_section', section);
        } catch (e) {}
      }

      $scope.$browseStateParams.category_title = category_title;
    };

    $scope.scrollToBlock = function () {
      $timeout(function () {
        if ($('#' + $scope.visibleContent + '-block')[0]) {
          $('.browse__content').animate(
            {
              scrollTop:
                $('#' + $scope.visibleContent + '-block').offset().top -
                $('.browse__content').offset().top +
                $('.browse__content').scrollTop(),
            },
            200
          );
        }
      }, 500);
    };

    if ($browseStateParams.visible_content) {
      $scope.visibleContent = $browseStateParams.visible_content;
    }

    if ($scope.$browseStateParams.pathway_type) {
      $scope.visibleContent = $browseStateParams.pathway_type + '_' + $browseStateParams.curriculum;
      $scope.scrollToBlock();
    }
  },
]);
